// extracted by mini-css-extract-plugin
module.exports = {"App":"Ingredient_App__JKFG3","IngredientContainer":"Ingredient_IngredientContainer__Vhf8_","Delete":"Ingredient_Delete__3GjLT"};